<div *ngIf="(uniqueUsers$ | async).length > 0" class="filter-container comment-filter-user" [formGroup]="form">
	<mat-form-field goSelect>
		<mat-label>{{ 'common_filter-by' | translate }}</mat-label>
		<mat-select
			multiple
			formControlName="selectedUsers"
			disableOptionCentering
			[placeholder]="'comment-filter-dropdown-placeholder' | translate"
			panelClass="offsetPanel commentFilterPanel">
			<mat-select-trigger>
				<!-- need this class for goSelect prepend label -->
				<span class="mat-mdc-select-min-line">
					<span *ngIf="allSelected.selected; else numSelected">{{ 'common_all' | translate }}</span>
					<ng-template #numSelected>
						<span class="num-selected-badge">{{ form.value.selectedUsers.length }}</span>
					</ng-template>
				</span>
			</mat-select-trigger>
			<mat-option
				#allSelected
				(click)="toggleAll()"
				[value]="0">
				{{ 'common_all' | translate}}
			</mat-option>
			<mat-option
				*ngFor="let user of uniqueUsers$ | async"
				(click)="toggleOne()"
				[value]="user.id">
				<span>{{ user.fullname }}<small>&nbsp;({{user.count}})</small></span>
			</mat-option>
		</mat-select>
		<mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
	</mat-form-field>
</div>
